import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable} from 'epic-alt-utils/index';

@seamlessImmutable
class MapsStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.state = Immutable({
            data: null
        });
    }
}

export default alt.createStore(MapsStore, 'MapsStore');
